<template>
  <div class="position-relative">
    <div class="item-wish">
      <a
        v-if="!selectedData.IsFavorite"
        class="btn-wish"
        @click.prevent="toggleFavorite(selectedData.IsFavorite)"
      >
        <i class="icon-wish" />
      </a>
      <a v-else class="btn-wish" @click.prevent="toggleFavorite(selectedData.IsFavorite)">
        <i class="icon-wish-active" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'WishlistBtn',
  computed: {
    ...mapState('shopContent', ['selectedData']),
  },
  methods: {
    ...mapActions('shopContent', ['toggleFavorite']),
  },
};
</script>
